/**
 * 列表数据转树形数据
 * @param data
 * @param options
 * @returns {Array}
 */
export const listToTree = (data, options) => {
  options = options || {}
  let ID_KEY = options.idKey || 'id'
  let PARENT_KEY = options.parentKey || 'parentId'
  let CHILDREN_KEY = options.childrenKey || 'children'

  let tree = []
  let childrenOf = {}
  let item, id, parentId

  for (let i = 0, length = data.length; i < length; i++) {
    item = data[i]
    id = item[ID_KEY]
    parentId = item[PARENT_KEY] || 0
    // every item may have children
    childrenOf[id] = childrenOf[id] || []
    // init its children
    item[CHILDREN_KEY] = childrenOf[id]
    if (parentId !== 0 && parentId !== -1) {
      // init its parent's children
      childrenOf[parentId] = childrenOf[parentId] || []
      // push it into its parent's children
      childrenOf[parentId].push(item)
    } else {
      tree.push(item)
    }
  }
  return tree
}


/**
 * 云课堂列表数据转树形数据
 * @param data
 * @param options
 * @returns {Array}
 */
export const listYktToTree = (data, options) => {
  options = options || {}
  let ID_KEY = options.idKey || 'catId'
  let PARENT_KEY = options.parentKey || 'parentId'
  let CHILDREN_KEY = options.childrenKey || 'children'

  let tree = []
  let childrenOf = {}
  let item, id, parentId

  for (let i = 0, length = data.length; i < length; i++) {
    item = data[i]
    id = item[ID_KEY]
    parentId = item[PARENT_KEY] || 0
    // every item may have children
    childrenOf[id] = childrenOf[id] || []
    // init its children
    item[CHILDREN_KEY] = childrenOf[id]
    if (parentId !== 0 && parentId !== -1) {
      // init its parent's children
      childrenOf[parentId] = childrenOf[parentId] || []
      // push it into its parent's children
      childrenOf[parentId].push(item)
    } else {
      tree.push(item)
    }
  }
  return tree
}


